var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{attrs:{"rotate":-90,"size":40,"width":7,"value":_vm.percentageValue,"color":"light-green"}},[_vm._v(" "+_vm._s(parseInt(_vm.min))+":"+_vm._s(_vm.sec)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }